import { toUrlParameters } from './util';
export class RichSessionRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async fetchSession(sessionId) {
        const response = await this.fetcher.fetchGetJson(`${RichSessionRemoteRepository.RICH_SESSIONS_PATH}/${sessionId}`);
        return RichSessionRemoteRepository.mapResponseToRichSession(response);
    }
    async fetchSessions() {
        const params = {
            contextId: this.contextId
        };
        const responses = await this.fetcher.fetchGetJson(`${RichSessionRemoteRepository.RICH_SESSIONS_PATH}?${toUrlParameters(params)}`);
        return responses.map(response => RichSessionRemoteRepository.mapResponseToRichSession(response));
    }
    static mapResponseToRichSession(response) {
        return {
            id: response.id,
            username: response.username,
            roles: response.roles,
            createDate: new Date(response.createDate),
            endDate: response.endDate ? new Date(response.endDate) : undefined,
            ipAddress: response.ipAddress,
            userUsername: response.userUsername
        };
    }
}
RichSessionRemoteRepository.RICH_SESSIONS_PATH = '/api/rich-sessions';
